import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enValidation from '../locales/en/validation.json'
import enCommon from '../locales/en/common.json'
import ruValidation from '../locales/ru/validation.json'
import ruCommon from '../locales/ru/common.json'
import esValidation from '../locales/es/validation.json'
import esCommon from '../locales/es/common.json'
import LanguageDetector from 'i18next-browser-languagedetector'

const resources = {
  en: {
    validation: enValidation,
    common: enCommon,
  },
  ru: {
    validation: ruValidation,
    common: ruCommon,
  },
  es: {
    validation: esValidation,
    common: esCommon,
  },
}

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    supportedLngs: ['es', 'en', 'ru'],

    fallbackLng: 'en',
    detection: {
      // Настройка порядка проверки (сначала куки, потом localStorage, затем navigator)
      order: ['localStorage', 'cookie', 'navigator', 'htmlTag'],
      // // Кешировать выбранный язык в localStorage и cookies для следующих визитов
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
